// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"be52267c","455":"d9edb18b","977":"c6c38730"}[chunkId] + ".chunk.js";
};